$(document).ready(function() {
 			
	$("#formLogin").validate();
	$("#formRegister").validate();
	$("#emailForm").validate();
	
	if(LoginRegister.wrongSite && LoginRegister.siteRedirectHost != "" && LoginRegister.siteRedirectCUI != ""){
		wrongSiteReDirect(LoginRegister.siteRedirectHost, LoginRegister.siteRedirectCUI, LoginRegister.rememberMe);
	}
	
	if(LoginRegister.containsGoogle=="true"){
		initClient(LoginRegister.googleId);
	}
	
	if(LoginRegister.containsVKontakte=="true") {
		VKLogin.init(4815180, 1);
	}
	
	$(".submitEmail").click(function(){
		var isvalid = $("#formRegister").valid();
		if (!isvalid)
			return false;
		
		var isEmailValid = emailValidation('registerMail');
		if (!isEmailValid)
			return false;		
		
		var agreeChecked = $("#loginagree").prop("checked");
		if (!agreeChecked) {
			alert(FmtMessage.getMessage('js.social.agreement.check.warning'));
			return;
		}else{
			$('#formRegister').submit();
		}
		
	});
	
	
	$(".fbButton").click(function(){
		
		FB.getLoginStatus(function(response) {
			
			if (response.status === 'connected') {
				 FB.api('/me?fields=id,first_name,last_name,email,birthday,gender,location', function(response) {
			        var gender = response.gender;
					if(gender == 'male'){
						gender = 1;
					} else if (gender == 'female'){
						gender = 2;
					}
			       loginSocialNetworkUser(response.id,"facebook",response.email,response.first_name,response.last_name,gender,response.birthday,null);
			     });
// 						doLogin(response.authResponse);				
			} else {
				FB.login(function(response){
					FB.api('/me?fields=id,first_name,last_name,email,birthday,gender,location', function(response) {
				        var gender = response.gender;
						if(gender == 'male'){
							gender = 1;
						} else if (gender == 'female'){
							gender = 2;
						}
				      loginSocialNetworkUser(response.id,"facebook",response.email,response.first_name,response.last_name,gender,response.birthday,null);
				    });
// 							doLogin(response.authResponse);	
				},
				{scope: 'email,user_birthday'});
			}
			
		});
		
	});
	
	$("#formRegister").letterCase($.cookie('siteLocale')).validate();
	
	//Strong Password
	$('.password-container').pschecker({ onPasswordValidate: validatePassword, onPasswordMatch: matchPassword });
	
	 var submitbutton = $('.submit-button');
	    var errorBox = $('.error');
	    errorBox.css('visibility', 'hidden');
	    submitbutton.attr("disabled", "disabled");

    //this function will handle onPasswordValidate callback, which mererly checks the password against minimum length
    function validatePassword(isValid) {
        if (!isValid)
            errorBox.css('visibility', 'visible');
        else
            errorBox.css('visibility', 'hidden');
    }
    //this function will be called when both passwords match
    function matchPassword(isMatched) {
        if (isMatched) {
            submitbutton.addClass('unlocked').removeClass('locked');
            submitbutton.removeAttr("disabled", "disabled");
        }
        else {
            submitbutton.attr("disabled", "disabled");
            submitbutton.addClass('locked').removeClass('unlocked');
        }
    }
	
	$('.agreementRegister').dialog({
		autoOpen: false,
		modal: true,
		dialogClass: 'agreeReg',
		show: "fade",
		hide: "fade",
		width: 600,
		height: 500
	});
	$("#subscriptionSocial").change(function() {
		if ($(this).is(":checked")) {  
			$("#subscriptionSocial").prop("checked", true); 
		} else {
			$("#subscriptionSocial").prop("checked", false); 
		}
	});		
	
		
});

function showAgreementDialog(){
	
	var html = FmtMessage.getMessage('js.page.rules.content.0') +
			   FmtMessage.getMessage('js.page.rules.content.1') +
			   FmtMessage.getMessage('js.page.rules.content.2') +
			   FmtMessage.getMessage('js.page.rules.content.3') +
			   FmtMessage.getMessage('js.page.rules.content.4') +
			   FmtMessage.getMessage('js.page.rules.content.5');
	
	$( ".agreementRegisterDiv" ).html(html);
	$( ".agreementRegister" ).dialog( "open" );
}

function showPrivacyPolicy() {

	$('<div title="' + FmtMessage.getMessage('js.general.privacyPolicy')+ '"></div>').load("/privacyPolicy").dialog({
		width : 500,
		height : 600,
		modal : true,
		resizable : false,
		draggable : false
	});
}

window.fbAsyncInit = function() {
	FB.init({
		appId : LoginRegister.facebookId,
		status : true,
		cookie : true,
		xfbml : true,
		oauth : true
	});
		
	if (window.location.pathname == "/logout") {

		function handleSessionResponse(response) {
			if (response.status != "connected") {
				window.location = window.location.protocol + "//"
						+ window.location.host;
			}

			// if we do have a non-null response.session, call FB.logout(),
			// the JS method will log the user out of Facebook and remove any
			// authorization cookies
			
			//logout removed C.Enc
			//FB.logout(handleSessionResponse);
			return;
		}
		
		FB.getLoginStatus(handleSessionResponse);
	} else {
		
/* 		if (autoLogin) {
		FB.getLoginStatus(function(response) {

			if (response.status == 'connected') {
				doLogin(response.authResponse);
			} else if (response.status == 'not_authorized') {
			} else {

				
				FB.Event.subscribe('auth.login', function(response) {
					if (response.status == 'connected') {
						
						doLogin(response.authResponse);
					}
				});
			   }
			
		}, true);
		 } */

	}
}

function refreshRegisterCaptcha(){
	var now = new Date();
	$('img[name=registerCaptchaImg]').attr("src", "/captcha?"+now.getTime());
}

function refreshForgetPasswordCaptcha(){
	var now = new Date();
	$("#forgetPasswordCaptchaImg").attr("src", "/captcha?"+now.getTime());
}

function wrongSiteReDirect(siteRedirectHost, siteRedirectCUI, rememberMe){
	
	openRedirectLoaderBox(siteRedirectHost);
	if(siteRedirectHost){
		setTimeout(function(){
			var preCodeHostName = "";
			if(window.location.host.indexOf("aerobilet.") > -1){
				preCodeHostName = window.location.host.substr(0,window.location.host.indexOf("aerobilet."))
			}
			var pathName = "/login";
			//var pathName = "${param.page_uri}" != "" ? "${param.page_uri}" : window.location.pathname;
			//var rememberMe = "${param.j_rememberme}" != "" ? "${param.j_rememberme}" : 0;
			window.location = window.location.protocol + "//"+preCodeHostName+siteRedirectHost+pathName+"?red_cui="+siteRedirectCUI+"&red_rm="+rememberMe;
			closeRedirectLoaderBox();
		}, 2000);
	}
}

/*
 * Site-redirect loader. Named distinctly because this file is injected by AJAX
 * after the page scripts have run - a shared name here silently replaced the
 * flight loader. Now delegates to the shared non-blocking IATILoader.
 */
var aerobilet_redirect_overlay = {
	show : function() { IATILoader.show(typeof LoginRegister !== 'undefined' ? LoginRegister.dialogMessage : ''); },
	hide : function() { IATILoader.hide(); }
};

function openRedirectLoaderBox(siteRedirectHost) {
	aerobilet_redirect_overlay.show();
}

function closeRedirectLoaderBox() {
	aerobilet_redirect_overlay.hide();
}

function showEmailSendDialog() {
	$('#forgetPasswordCaptchaImg').attr('src', '/captcha');

	$(".forgotPassword").dialog({
		modal : true,
		resizable:false,
		draggable:false,
		width : 600
	});
}

function onForgotPassword(){
	$.ajax({
		type : "POST",
		async : true,
		url : "/forgotPassword", 
		dataType : 'json',
		data: $("#emailForPassword").serialize(),
		success : function(response) {
			if(response.result) {
				
			}
		},
		error : function(xhr, ajaxOptions, errorThrown) {
			
		}

	}).fail(function() {
		
	});
}


function loginSocialNetworkUser(snUserId,snKey,email,name,surname,gender,birthdate, inviteUserId){
	
	$.ajax({
		url : '/login/socialNetwork',
		dataType : "json",
		type : 'POST',
		data : {
			snUserId: snUserId,
			snKey: snKey,
			email:  email,
			name: name,
			surname: surname,
			gender: gender,
			birthdate: birthdate,
			inviteUserId: inviteUserId
		},
		success : function(data) {
			var user = data.user;
			var result = data.result;
			
			if(result != "true"){
				return;
			}else if(data.errorCode == "20210"){
				var redirectHostName = "";
				if(user && user.defaultHostName ){			
					var preCodeHostName = "";
					if(window.location.host.indexOf("aerobilet.") > -1){
						preCodeHostName = window.location.host.substr(0,window.location.host.indexOf("aerobilet."))
					}
					redirectHostName = preCodeHostName + user.defaultHostName;
				}
				var alertText = "<p class='alert' style='color: red;'><fmt:message key='error.login.wrongSite'> ";
				alertText = alertText + "<fmt:param><a href='https://" + redirectHostName + "'>" + redirectHostName + "</a></fmt:param>";
				alertText = alertText + "</fmt:message></p>";
				$("#loginError").html(alertText);
				if(user && user.defaultHostName ){
					wrongSiteReDirect(user.defaultHostName, user.cookieUserId, true)
				}
				return;
			} else if (user) {
				window.location =  "/workplace";
			} else { //registerUser
				
				$("#email-form-"+snKey).dialog({
					autoOpen: false,
					modal: true,
					show: "fade",
					hide: "fade",
					 buttons: {
						 "<fmt:message key='vkontakte.email.send' />": function() {
							 if($("#email-form-"+snKey).find("#email").validate()){
									email = $("#email-form-"+snKey).find("#email").val();	
									loginSocialNetworkUser(snUserId,snKey,email,name,surname,gender,birthdate, inviteUserId); //set email and retry login(register)
									$("#email-form-"+snKey).dialog("close");
								}
						 },
						 "<fmt:message key='vkontakte.email.cancel' />": function() {
							 $("#email-form-"+snKey).dialog("close");
						 }
					 }
				});
				
				$("#email-form-"+snKey).dialog("open");
				
			}
		},
		complete : function(xhr,status) {
			var a = 0;
		}
	});
	
}

